/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ChildActionsUnionModelSelector } from "./ChildActionsUnionModelSelector"
import { DriverActionDtoModel, DriverActionDtoModelType } from "./DriverActionDtoModel"
import { DriverActionDtoModelSelector } from "./DriverActionDtoModel.base"
import { EngineActionDtoModel, EngineActionDtoModelType } from "./EngineActionDtoModel"
import { EngineActionDtoModelSelector } from "./EngineActionDtoModel.base"
import { PlanningActionOutputDtoModel, PlanningActionOutputDtoModelType } from "./PlanningActionOutputDtoModel"
import { PlanningActionOutputDtoModelSelector } from "./PlanningActionOutputDtoModel.base"
import { PlanningActionsStatusEnumType } from "./PlanningActionsStatusEnum"
import { RouteActionDtoModel, RouteActionDtoModelType } from "./RouteActionDtoModel"
import { RouteActionDtoModelSelector } from "./RouteActionDtoModel.base"
import { VisitActionDtoModel, VisitActionDtoModelType } from "./VisitActionDtoModel"
import { VisitActionDtoModelSelector } from "./VisitActionDtoModel.base"
import { RootStoreType } from "./index"


/**
 * PlanningActionsDtoBase
 * auto generated base class for the model PlanningActionsDtoModel.
 */
export const PlanningActionsDtoModelBase = ModelBase
  .named('PlanningActionsDto')
  .props({
    __typename: types.optional(types.literal("PlanningActionsDto"), "PlanningActionsDto"),
    id: types.identifier,
    organizationId: types.union(types.undefined, types.integer),
    projectId: types.union(types.undefined, types.integer),
    startDate: types.union(types.undefined, types.string),
    userUuid: types.union(types.undefined, types.string),
    workflowUuid: types.union(types.undefined, types.string),
    actionUuid: types.union(types.undefined, types.string),
    actionName: types.union(types.undefined, types.string),
    input: types.union(types.undefined, types.null, types.frozen()),
    status: types.union(types.undefined, PlanningActionsStatusEnumType),
    detail: types.union(types.undefined, types.string),
    output: types.union(types.undefined, types.null, types.late((): any => PlanningActionOutputDtoModel)),
    createdAt: types.union(types.undefined, types.string),
    updatedAt: types.union(types.undefined, types.string),
    finishedAt: types.union(types.undefined, types.string),
    childActions: types.union(types.undefined, types.null, types.array(types.union(types.late((): any => EngineActionDtoModel), types.late((): any => VisitActionDtoModel), types.late((): any => DriverActionDtoModel), types.late((): any => RouteActionDtoModel)))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PlanningActionsDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get organizationId() { return this.__attr(`organizationId`) }
  get projectId() { return this.__attr(`projectId`) }
  get startDate() { return this.__attr(`startDate`) }
  get userUuid() { return this.__attr(`userUuid`) }
  get workflowUuid() { return this.__attr(`workflowUuid`) }
  get actionUuid() { return this.__attr(`actionUuid`) }
  get actionName() { return this.__attr(`actionName`) }
  get input() { return this.__attr(`input`) }
  get status() { return this.__attr(`status`) }
  get detail() { return this.__attr(`detail`) }
  get createdAt() { return this.__attr(`createdAt`) }
  get updatedAt() { return this.__attr(`updatedAt`) }
  get finishedAt() { return this.__attr(`finishedAt`) }
  output(builder: string | PlanningActionOutputDtoModelSelector | ((selector: PlanningActionOutputDtoModelSelector) => PlanningActionOutputDtoModelSelector) | undefined) { return this.__child(`output`, PlanningActionOutputDtoModelSelector, builder) }
  childActions(builder: string | ChildActionsUnionModelSelector | ((selector: ChildActionsUnionModelSelector) => ChildActionsUnionModelSelector) | undefined) { return this.__child(`childActions`, ChildActionsUnionModelSelector, builder) }
}
export function selectFromPlanningActionsDto() {
  return new PlanningActionsDtoModelSelector()
}

export const planningActionsDtoModelPrimitives = selectFromPlanningActionsDto().organizationId.projectId.startDate.userUuid.workflowUuid.actionUuid.actionName.input.status.detail.createdAt.updatedAt.finishedAt
